export default [
    {id: "Abdominal Radiology", text: "Abdominal Radiology"},
    {id: "Addiction Psychiatry", text: "Addiction Psychiatry"},
    {id: "Adolescent Medicine", text: "Adolescent Medicine"},
    {id: "Adult Reconstructive Orthopaedics", text: "Adult Reconstructive Orthopaedics"},
    {
        id: "Advanced Heart Failure & Transplant Cardiology",
        text: "Advanced Heart Failure & Transplant Cardiology"
    },
    {id: "Allergy & Immunology", text: "Allergy & Immunology"},
    {id: "Anesthesiology", text: "Anesthesiology"},
    {id: "Biochemical Genetics", text: "Biochemical Genetics"},
    {id: "Blood Banking - Transfusion Medicine", text: "Blood Banking -T ransfusion Medicine"},
    {id: "Cardiology", text: "Cardiology"},
    {id: "Cardiothoracic Radiology", text: "Cardiothoracic Radiology"},
    {id: "Cardiovascular Disease", text: "Cardiovascular Disease"},
    {id: "Chemical Pathology", text: "Chemical Pathology"},
    {id: "Child & Adolescent Psychiatry", text: "Child & Adolescent Psychiatry"},
    {id: "Child Abuse Pediatrics", text: "Child Abuse Pediatrics"},
    {id: "Child Neurology", text: "Child Neurology"},
    {id: "Clinical & Laboratory Immunology", text: "Clinical & Laboratory Immunology"},
    {id: "Clinical Cardiac Electrophysiology", text: "Clinical Cardiac Electrophysiology"},
    {id: "Clinical Neurophysiology", text: "Clinical Neurophysiology"},
    {id: "Colon & Rectal Surgery", text: "Colon & Rectal Surgery"},
    {id: "Congenital Cardiac Surgery", text: "Congenital Cardiac Surgery"},
    {id: "Craniofacial Surgery", text: "Craniofacial Surgery"},
    {id: "Critical Care Medicine", text: "Critical Care Medicine"},
    {id: "Cytopathology", text: "Cytopathology"},
    {id: "Dermatology", text: "Dermatology"},
    {id: "Dermatopathology", text: "Dermatopathology"},
    {id: "Developmental-Behavioral Pediatrics", text: "Developmental-Behavioral Pediatrics"},
    {id: "Ears, Nose, Throat (ENT)", text: "Ears, Nose, Throat (ENT)"},
    {id: "Emergency Medicine", text: "Emergency Medicine"},
    {id: "Endocrinology, Diabetes & Metabolism", text: "Endocrinology, Diabetes & Metabolism"},
    {id: "Endovascular Surgical Neuroradiology", text: "Endovascular Surgical Neuroradiology"},
    {id: "Family Medicine", text: "Family Medicine"},
    {id: "Family Practice", text: "Family Practice"},
    {
        id: "Female Pelvic Medicine & Reconstructive Surgery",
        text: "Female Pelvic Medicine & Reconstructive Surgery"
    },
    {id: "Foot & Ankle Orthopaedics", text: "Foot & Ankle Orthopaedics"},
    {id: "Forensic Pathology", text: "Forensic Pathology"},
    {id: "Forensic Psychiatry", text: "Forensic Psychiatry"},
    {id: "Gastroenterology", text: "Gastroenterology"},
    {id: "Geriatric Medicine", text: "Geriatric Medicine"},
    {id: "Geriatric Psychiatry", text: "Geriatric Psychiatry"},
    {id: "Hand Surgery", text: "Hand Surgery"},
    {id: "Hematology", text: "Hematology"},
    {id: "Hematology & Oncology", text: "Hematology & Oncology"},
    {id: "Homecare Nurse", text: "Homecare Nurse"},
    {id: "Infectious Disease", text: "Infectious Disease"},
    {id: "Internal Medicine", text: "Internal Medicine"},
    {id: "Internal Medicine-Pediatrics", text: "Internal Medicine-Pediatrics"},
    {id: "Interventional Cardiology", text: "Interventional Cardiology"},
    {id: "MD", text: "MD"},
    {id: "Medical Genetics", text: "Medical Genetics"},
    {id: "Medical Microbiology", text: "Medical Microbiology"},
    {id: "Medical Toxicology", text: "Medical Toxicology"},
    {id: "Molecular Genetic Pathology", text: "Molecular Genetic Pathology"},
    {id: "Muscoskeletal Radiology", text: "Muscoskeletal Radiology"},
    {id: "Musculoskeletal Oncology", text: "Musculoskeletal Oncology"},
    {id: "Neonatal-Perinatal Medicine", text: "Neonatal-Perinatal Medicine"},
    {id: "Nephrology", text: "Nephrology"},
    {id: "Neurological Surgery", text: "Neurological Surgery"},
    {id: "Neurology", text: "Neurology"},
    {id: "Neuromuscular Medicine", text: "Neuromuscular Medicine"},
    {id: "Neuroradiology", text: "Neuroradiology"},
    {id: "Nuclear Medicine", text: "Nuclear Medicine"},
    {id: "Nuclear Radiology", text: "Nuclear Radiology"},
    {id: "Obstetric Anesthesiology", text: "Obstetric Anesthesiology"},
    {id: "Obstetrics & Gynecology", text: "Obstetrics & Gynecology"},
    {id: "Oncology", text: "Oncology"},
    {
        id: "Ophthalmic Plastic & Reconstructive Surgery",
        text: "Ophthalmic Plastic & Reconstructive Surgery"
    },
    {id: "Ophthalmology", text: "Ophthalmology"},
    {id: "Orthopaedic Sports Medicine", text: "Orthopaedic Sports Medicine"},
    {id: "Orthopaedic Surgery", text: "Orthopaedic Surgery"},
    {id: "Orthopaedic Surgery of the Spine", text: "Orthopaedic Surgery of the Spine"},
    {id: "Orthopaedic Trauma", text: "Orthopaedic Trauma"},
    {id: "Otolaryngology", text: "Otolaryngology"},
    {id: "Otology - Neurotology", text: "Otology - Neurotology"},
    {id: "Pain Medicine", text: "Pain Medicine"},
    {id: "Pathology-Anatomic & Clinical", text: "Pathology-Anatomic & Clinical"},
    {id: "Pediatric Anesthesiology", text: "Pediatric Anesthesiology"},
    {id: "Pediatric Cardiology", text: "Pediatric Cardiology"},
    {id: "Pediatric Critical Care Medicine", text: "Pediatric Critical Care Medicine"},
    {id: "Pediatric Emergency Medicine", text: "Pediatric Emergency Medicine"},
    {id: "Pediatric Endocrinology", text: "Pediatric Endocrinology"},
    {id: "Pediatric Gastroenterology", text: "Pediatric Gastroenterology"},
    {id: "Pediatric Hematology-Oncology", text: "Pediatric Hematology-Oncology"},
    {id: "Pediatric Infectious Diseases", text: "Pediatric Infectious Diseases"},
    {id: "Pediatric Nephrology", text: "Pediatric Nephrology"},
    {id: "Pediatric Orthopaedics", text: "Pediatric Orthopaedics"},
    {id: "Pediatric Otolaryngology", text: "Pediatric Otolaryngology"},
    {id: "Pediatric Pathology", text: "Pediatric Pathology"},
    {id: "Pediatric Pulmonology", text: "Pediatric Pulmonology"},
    {id: "Pediatric Radiology", text: "Pediatric Radiology"},
    {id: "Pediatric Rheumatology", text: "Pediatric Rheumatology"},
    {id: "Pediatric Sports Medicine", text: "Pediatric Sports Medicine"},
    {id: "Pediatric Surgery", text: "Pediatric Surgery"},
    {id: "Pediatric Transplant Hepatology", text: "Pediatric Transplant Hepatology"},
    {id: "Pediatric Urology", text: "Pediatric Urology"},
    {id: "Pediatrics", text: "Pediatrics"},
    {id: "Physical Medicine & Rehabilitation", text: "Physical Medicine & Rehabilitation"},
    {id: "Physical Therapy", text: "Physical Therapy"},
    {id: "Plastic Surgery", text: "Plastic Surgery"},
    {id: "Preventive Medicine", text: "Preventive Medicine"},
    {id: "Procedural Dermatology", text: "Procedural Dermatology"},
    {id: "Psychiatry", text: "Psychiatry"},
    {id: "Pulmonary Disease", text: "Pulmonary Disease"},
    {
        id: "Pulmonary Disease & Critical Care Medicine",
        text: "Pulmonary Disease & Critical Care Medicine"
    },
    {id: "Radiation Oncology", text: "Radiation Oncology"},
    {id: "Radiology-Diagnostic", text: "Radiology-Diagnostic"},
    {id: "Rheumatology", text: "Rheumatology"},
    {id: "Sleep Medicine", text: "Sleep Medicine"},
    {id: "Social Worker", text: "Social Worker"},
    {id: "Spinal Cord Injury Medicine", text: "Spinal Cord Injury Medicine"},
    {id: "Sports Medicine", text: "Sports Medicine"},
    {id: "Surgery-General", text: "Surgery-General"},
    {id: "Surgical Critical Care", text: "Surgical Critical Care"},
    {id: "Therapist", text: "Therapist"},
    {id: "Thoracic Surgery", text: "Thoracic Surgery"},
    {id: "Thoracic Surgery-Integrated", text: "Thoracic Surgery-Integrated"},
    {id: "Transplant Hepatology", text: "Transplant Hepatology"},
    {id: "Urology", text: "Urology"},
    {id: "Vascular & Interventional Radiology", text: "Vascular & Interventional Radiology"},
    {id: "Vascular Surgery", text: "Vascular Surgery"},
];
